{
  "nav": { "items": { "myPage": "صفحهٔ من" } },
  "myPage": {
    "subtitle": "صفحهٔ اختصاصی شما در {{brand}}: قالب را انتخاب کنید، بخش‌ها را بچینید و منتشر کنید.",
    "loading": "در حال آماده‌سازی صفحهٔ شما",
    "loadFailed": "صفحهٔ شما بارگذاری نشد",
    "railLabel": "تنظیمات صفحه",
    "markdownHint": "قالب‌بندی ساده پشتیبانی می‌شود: # تیتر، **پررنگ**، فهرست با - و پیوند به صورت [متن](https://…). HTML پذیرفته نمی‌شود.",
    "markdownHintShort": "**پررنگ**، فهرست با - و پیوند پشتیبانی می‌شود.",
    "tabs": { "label": "بخش‌های صفحهٔ من", "builder": "ویرایش صفحه", "leads": "درخواست‌های صفحه" },
    "status": {
      "draft": "پیش‌نویس",
      "published": "منتشرشده",
      "unpublished": "لغو انتشار",
      "suspended": "معلق",
      "unknown": "نامشخص"
    },
    "statusCard": {
      "title": "وضعیت صفحه",
      "liveUrl": "نشانی صفحهٔ شما",
      "futureUrl": "پس از انتشار، صفحه در این نشانی در دسترس خواهد بود",
      "copy": "کپی نشانی",
      "copied": "نشانی کپی شد",
      "copyFailed": "کپی نشانی ممکن نشد",
      "lastPublished": "آخرین انتشار: {{date}}",
      "preview": "پیش‌نمایش",
      "openPreview": "باز کردن پیش‌نمایش",
      "popupBlocked": "مرورگر پنجرهٔ پیش‌نمایش را مسدود کرد؛ از پیوند زیر استفاده کنید.",
      "publish": "انتشار",
      "republish": "انتشار تغییرات",
      "unpublish": "لغو انتشار",
      "unpublishTitle": "لغو انتشار صفحه؟",
      "unpublishBody": "صفحه از اینترنت برداشته می‌شود و نشانی آن دیگر باز نمی‌شود. همهٔ محتوا حفظ می‌شود و می‌توانید دوباره منتشر کنید.",
      "unpublishConfirm": "لغو انتشار کن",
      "unpublished": "انتشار صفحه لغو شد",
      "unpublishFailed": "لغو انتشار انجام نشد. دوباره تلاش کنید.",
      "blockersTitle": "برای انتشار، این موارد را کامل کنید:",
      "addCouncil": "ثبت کد نظام پزشکی در پروفایل"
    },
    "banner": {
      "suspendedTitle": "صفحهٔ شما توسط {{brand}} معلق شده است",
      "suspendedNoReason": "دلیلی ثبت نشده است.",
      "suspendedSupport": "صفحه فقط‌خواندنی است. برای رفع تعلیق با پشتیبانی {{brand}} تماس بگیرید.",
      "unpublishedChanges": "تغییراتی دارید که هنوز منتشر نشده‌اند؛ بازدیدکنندگان نسخهٔ قبلی را می‌بینند."
    },
    "save": {
      "save": "ذخیره",
      "reset": "بازنشانی",
      "saving": "در حال ذخیره…",
      "saved": "ذخیره شد",
      "dirty": "تغییرات ذخیره نشده"
    },
    "publish": {
      "title": "انتشار صفحه",
      "intro": "صفحهٔ شما با انتشار، برای همه در اینترنت قابل مشاهده و جست‌وجو می‌شود. پیش از انتشار این موارد را تأیید کنید:",
      "rule1": "محتوای صفحه با ضوابط تبلیغات سازمان نظام پزشکی سازگار است و ادعای درمان قطعی، تضمین نتیجه یا مقایسه با همکاران ندارد.",
      "rule2": "تصاویر و نوشته‌ها متعلق به شماست یا اجازهٔ استفاده از آن‌ها را دارید.",
      "rule3": "نظرات بیماران با رضایت خود آن‌ها منتشر می‌شود و هیچ اطلاعات پزشکی شخصی در صفحه نیست.",
      "rule4": "مسئولیت محتوای صفحه با شماست و {{brand}} می‌تواند صفحهٔ ناسازگار با این ضوابط را معلق کند.",
      "public": "صفحه عمومی است: هر کسی با نشانی آن، و موتورهای جست‌وجو، آن را می‌بینند.",
      "accept": "این موارد را خواندم و می‌پذیرم",
      "confirm": "منتشر کن",
      "cancel": "انصراف",
      "failedTitle": "انتشار انجام نشد؛ این موارد را اصلاح کنید",
      "done": "صفحهٔ شما منتشر شد"
    },
    "template": { "title": "قالب" },
    "templates": {
      "classic": { "name": "کلاسیک", "description": "چاپی و متین: عکس قاب‌شده، تیتر بزرگ با خط‌کشی رنگی، تصویر پس‌زمینه به‌صورت نوار بالای صفحه و نوار نکات برجسته." },
      "modern": { "name": "مدرن", "description": "شبیه صفحهٔ اول سایت یک کلینیک: تیتر بزرگ، تصویر پس‌زمینه، کارت‌های کنار عکس و نوار نکات برجسته." },
      "minimal": { "name": "مینیمال", "description": "تایپوگرافیک و خلوت، بدون کاور؛ تمرکز بر متن، خدمات و مقالات." }
    },
    "palettes": {
      "azure": "لاجوردی",
      "teal": "فیروزه‌ای",
      "deep": "سرمه‌ای",
      "brand": "برند {{brand}}",
      "cyan": "آبی فیروزه‌ای",
      "ink": "جوهری"
    },
    "theme": {
      "title": "رنگ و تراکم",
      "palette": "رنگ‌بندی",
      "density": "تراکم",
      "densities": { "comfortable": "راحت", "compact": "فشرده" },
      "onlyTemplate": "فقط رنگ‌ها و تراکم‌هایی نمایش داده می‌شود که قالب فعلی پشتیبانی می‌کند."
    },
    "slug": {
      "label": "نشانی صفحه",
      "hint": "حروف کوچک انگلیسی، عدد و خط تیره؛ ۳ تا ۴۰ نویسه. پیش‌فرض، کد نظام پزشکی شماست.",
      "lockedHint": "نشانی پس از نخستین انتشار ثابت شده و دیگر تغییر نمی‌کند.",
      "required": "نشانی را وارد کنید.",
      "invalid": "فقط حروف کوچک انگلیسی، عدد و خط تیره، ۳ تا ۴۰ نویسه؛ با حرف یا عدد شروع و تمام شود و دو خط تیرهٔ پشت‌سرهم نداشته باشد.",
      "checking": "در حال بررسی…",
      "available": "این نشانی آزاد است.",
      "taken": "این نشانی در دسترس نیست.",
      "save": "ذخیرهٔ نشانی"
    },
    "sections": {
      "title": "بخش‌ها",
      "reorderHint": "با دکمه‌های بالا و پایین (یا Alt و کلیدهای جهت) ترتیب را تغییر دهید.",
      "kinds": {
        "hero": "پروفایل حرفه‌ای",
        "services": "خدمات",
        "articles": "مقالات و مطالب علمی",
        "testimonials": "نظرات منتخب بیماران",
        "gallery": "گالری تصاویر",
        "video": "ویدیو",
        "office": "اطلاعات مطب",
        "booking": "نوبت‌دهی"
      },
      "show": "نمایش «{{name}}» در صفحه",
      "shown": "نمایش داده می‌شود",
      "hidden": "پنهان",
      "hiddenNotice": "این بخش پنهان است و در صفحهٔ عمومی نمایش داده نمی‌شود.",
      "showOnPage": "نمایش در صفحه",
      "toggleFailed": "تغییر نمایش «{{name}}» ذخیره نشد:",
      "required": "این بخش همیشه نمایش داده می‌شود",
      "moveUp": "انتقال «{{name}}» به بالا",
      "moveDown": "انتقال «{{name}}» به پایین",
      "unsupported": "در این قالب نمایش داده نمی‌شود",
      "unsupportedLong": "قالب فعلی این بخش را نمایش نمی‌دهد. محتوای آن حفظ می‌شود و با تغییر قالب دوباره نمایش داده می‌شود.",
      "hasErrors": "این بخش مانع انتشار است",
      "titleOverride": "عنوان بخش (اختیاری)",
      "titleOverrideHint": "خالی بگذارید تا عنوان پیش‌فرض نمایش داده شود.",
      "reorderFailed": "ترتیب بخش‌ها ذخیره نشد. دوباره تلاش کنید.",
      "booking": {
        "intro": "بازدیدکنندهٔ صفحه می‌تواند از زمان‌های آزاد شما در یک کلینیک وقت انتخاب کند یا فقط درخواست تماس بفرستد. عمومی‌بودن و رزرو مستقیم هر خدمت را کلینیک تعیین می‌کند.",
        "enabled": "نمایش نوبت‌دهی در صفحه",
        "enabledHint": "با خاموش‌بودن، فقط فرم «درخواست تماس» در صفحه می‌ماند.",
        "clinic": "کلینیک",
        "clinicPlaceholder": "انتخاب کلینیک",
        "clinicSingleHint": "تنها کلینیکی که در آن عضو هستید.",
        "noClinicsTitle": "برای نوبت‌دهی باید عضو یک کلینیک باشید",
        "noClinicsBody": "عضویت از بخش «کلینیک‌ها» در تنظیمات انجام می‌شود.",
        "goClinics": "کلینیک‌ها",
        "mode": "نحوهٔ نوبت‌دهی",
        "modes": { "slots": "انتخاب وقت از زمان‌های آزاد", "request": "فقط درخواست تماس" },
        "modeHints": {
          "slots": "بازدیدکننده زمان‌های آزاد را می‌بیند و با ورود به اپ بیمار رزرو می‌کند.",
          "request": "فقط فرم «درخواست تماس» نمایش داده می‌شود."
        },
        "services": "خدمات",
        "servicesHint": "فقط خدماتی که کلینیک عمومی کرده است نمایش داده می‌شود. خدمت «با ارجاع پزشک» با همین نشان نمایش داده می‌شود و بازدیدکننده نمی‌تواند آن را مستقیم رزرو کند.",
        "servicesEmpty": "این کلینیک هنوز خدمت عمومی‌ای برای شما ندارد.",
        "kinds": { "direct": "رزرو مستقیم", "referral": "با ارجاع پزشک" },
        "duration": "{{minutes}} دقیقه",
        "unavailable": "دیگر عمومی نیست",
        "unavailableHint": "خدمتی که دیگر عمومی نیست هنگام ذخیره حذف می‌شود.",
        "horizon": "افق نمایش",
        "horizonDays": "{{days}} روز",
        "horizonHint": "زمان‌های آزاد تا این تعداد روز آینده نمایش داده می‌شود.",
        "previewNote": "زمان‌های آزاد در صفحهٔ منتشرشده نمایش داده می‌شود.",
        "loadFailed": "گزینه‌های نوبت‌دهی بارگذاری نشد",
        "errors": {
          "BOOKING_CLINIC_REQUIRED": "کلینیک را انتخاب کنید.",
          "BOOKING_CLINIC_NOT_MEMBER": "شما دیگر عضو این کلینیک نیستید؛ کلینیک دیگری انتخاب کنید.",
          "BOOKING_SERVICES_REQUIRED": "دست‌کم یک خدمت انتخاب کنید.",
          "BOOKING_SERVICE_UNAVAILABLE": "برخی خدمات انتخاب‌شده دیگر عمومی نیستند و با ذخیره حذف می‌شوند."
        }
      }
    },
    "items": {
      "count": "{{count}} از {{max}}",
      "moveUp": "انتقال به بالا",
      "moveDown": "انتقال به پایین",
      "remove": "حذف"
    },
    "image": {
      "pick": "انتخاب تصویر",
      "replace": "تغییر تصویر",
      "remove": "حذف تصویر",
      "removeTitle": "حذف تصویر؟",
      "removeBody": "تصویر از صفحه حذف می‌شود. پس از انتشار دوباره، از صفحهٔ عمومی هم برداشته می‌شود.",
      "removeConfirm": "حذف کن",
      "cropTitle": "برش تصویر",
      "typeUnsupported": "فقط تصویر JPEG یا PNG پذیرفته می‌شود.",
      "tooLarge": "حجم تصویر بیش از ۵ مگابایت است.",
      "readFailed": "خواندن فایل ممکن نشد."
    },
    "hero": {
      "displayName": "نام نمایشی",
      "displayNameRequired": "نام نمایشی لازم است.",
      "headline": "عنوان کوتاه",
      "headlinePlaceholder": "مثلاً متخصص قلب و عروق، عضو هیئت علمی",
      "headlineHint": "در قالب‌های «مدرن» و «کلاسیک» با حروف بزرگ بالای صفحه می‌آید؛ اگر «،» داشته باشد، بخش بعد از آن رنگی نمایش داده می‌شود.",
      "about": "درباره من",
      "portrait": "تصویر پرتره",
      "portraitHint": "نسخه‌ای جداگانه از تصویر پروفایل شما؛ تغییر آن روی پروفایل اثری ندارد.",
      "cover": "تصویر پس‌زمینه",
      "coverHint": "تصویر عریض (نسبت حدود ۳ به ۱). در قالب «مدرن» کم‌رنگ و محو پشت بخش بالای صفحه می‌آید و در قالب «کلاسیک» به‌صورت نواری بالای صفحه.",
      "coverUnused": "قالب فعلی تصویر پس‌زمینه را نمایش نمی‌دهد؛ برای دیدن آن قالب «مدرن» یا «کلاسیک» را انتخاب کنید.",
      "extras": {
        "onlyModern": "این دو فهرست در قالب‌های «مدرن» و «کلاسیک» نمایش داده می‌شوند. اگر خالی بمانند، خدمات اول شما و شمارهٔ نظام، شهر و ساعات کاری جای آن‌ها می‌آید.",
        "notShown": "قالب فعلی این دو فهرست را نمایش نمی‌دهد؛ برای دیدن آن‌ها قالب «مدرن» یا «کلاسیک» را انتخاب کنید.",
        "cardsTitle": "کارت‌های معرفی",
        "cardsHint": "حداکثر دو کارت کوتاه در بخش بالای صفحه؛ مثلاً «ویزیت حضوری و آنلاین».",
        "addCard": "افزودن کارت",
        "highlightsTitle": "نکات برجسته",
        "highlightsHint": "حداکثر سه مورد در نوار زیر بخش بالای صفحه؛ مثلاً «۱۵ سال تجربه».",
        "addHighlight": "افزودن نکته",
        "itemTitle": "عنوان",
        "itemText": "توضیح کوتاه (اختیاری)",
        "titleRequired": "عنوان لازم است."
      }
    },
    "services": {
      "itemTitle": "عنوان خدمت",
      "itemDescription": "توضیح",
      "image": "تصویر خدمت",
      "imageHint": "نسبت ۴ به ۳؛ عنوان خدمت به عنوان متن جایگزین تصویر استفاده می‌شود.",
      "imageAfterSave": "پس از ذخیرهٔ این خدمت می‌توانید تصویر اضافه کنید.",
      "add": "افزودن خدمت"
    },
    "testimonials": {
      "framingTitle": "نظرات منتخب، نه امتیازدهی",
      "framing": "این بخش نقل‌قول‌هایی است که خودتان انتخاب و وارد می‌کنید و با عنوان «نظرات منتخب بیماران» نمایش داده می‌شود. امتیاز، ستاره یا شمارش نظر در صفحه نمایش داده نمی‌شود.",
      "text": "متن نظر",
      "attribution": "نام نمایشی بیمار",
      "attributionPlaceholder": "مثلاً «م. رضایی» یا «بیمار ۴۵ ساله»",
      "consent": "بیمار با انتشار این نظر در صفحهٔ عمومی موافقت کرده است",
      "consentRequired": "بدون تأیید رضایت بیمار، این نظر ذخیره نمی‌شود.",
      "add": "افزودن نظر"
    },
    "video": {
      "intro": "نشانی ویدیو را از آپارات یا یوتیوب بچسبانید؛ فقط شناسهٔ ویدیو ذخیره می‌شود.",
      "url": "نشانی ویدیو",
      "caption": "توضیح کوتاه",
      "add": "افزودن ویدیو",
      "pending": "پس از ذخیره بررسی می‌شود",
      "aparat": "آپارات",
      "youtube": "یوتیوب"
    },
    "gallery": {
      "alt": "متن جایگزین",
      "altRequired": "متن جایگزین لازم است.",
      "saveAlt": "ذخیرهٔ متن",
      "newAlt": "توضیح تصویر جدید",
      "newAltPlaceholder": "مثلاً «اتاق انتظار مطب»",
      "altFirst": "ابتدا توضیح تصویر را بنویسید.",
      "emptyTitle": "هنوز تصویری در گالری نیست",
      "emptyHint": "تا ۱۲ تصویر از مطب و تجهیزات اضافه کنید."
    },
    "articles": {
      "new": "مقالهٔ جدید",
      "back": "بازگشت به فهرست مقالات",
      "title": "عنوان مقاله",
      "slug": "نشانی مقاله (اختیاری)",
      "slugHint": "خالی بگذارید تا از عنوان ساخته شود. پس از نخستین انتشار ثابت می‌شود.",
      "slugLocked": "نشانی مقاله:",
      "body": "متن مقاله",
      "cover": "تصویر مقاله",
      "publish": "انتشار مقاله",
      "unpublish": "بازگرداندن به پیش‌نویس",
      "republish": "انتشار تغییرات مقاله",
      "delete": "حذف مقاله",
      "deleteTitle": "حذف مقاله؟",
      "deleteBody": "مقالهٔ «{{title}}» برای همیشه حذف می‌شود.",
      "deleteConfirm": "حذف کن",
      "saveFirst": "برای انتشار، ابتدا تغییرات را ذخیره کنید.",
      "saveToContinue": "پس از ذخیره می‌توانید تصویر اضافه کنید و مقاله را منتشر کنید.",
      "untitled": "بدون عنوان",
      "publishedOn": "منتشرشده در {{date}}",
      "neverPublished": "هنوز منتشر نشده",
      "statusPublished": "منتشرشده",
      "statusDraft": "پیش‌نویس",
      "changed": "تغییرات منتشرنشده",
      "emptyTitle": "هنوز مقاله‌ای ننوشته‌اید",
      "emptyHint": "مطالب آموزشی برای بیماران، صفحهٔ شما را در جست‌وجو دیده‌تر می‌کند."
    },
    "office": {
      "intro": "اطلاعاتی که اینجا وارد می‌کنید عیناً در صفحهٔ عمومی نمایش داده می‌شود.",
      "phones": "تلفن‌ها",
      "phoneLabel": "عنوان",
      "phoneLabelPlaceholder": "مثلاً منشی",
      "phoneNumber": "شماره",
      "addPhone": "افزودن تلفن",
      "city": "شهر",
      "address": "نشانی مطب",
      "hours": "ساعات کاری",
      "hoursLabel": "روز",
      "hoursLabelPlaceholder": "مثلاً شنبه تا چهارشنبه",
      "hoursValue": "ساعت",
      "hoursValuePlaceholder": "مثلاً ۱۶ تا ۲۰",
      "addHours": "افزودن ساعت کاری",
      "geo": "موقعیت روی نقشه (اختیاری)",
      "geoHint": "مطب را روی نقشه مشخص کنید تا بیماران از صفحهٔ شما با نشان، بلد یا گوگل‌مپ مسیریابی کنند.",
      "map": {
        "pick": "انتخاب روی نقشه",
        "change": "تغییر روی نقشه",
        "close": "بستن نقشه",
        "myLocation": "موقعیت فعلی من",
        "clear": "حذف موقعیت",
        "isSet": "موقعیت مطب روی نقشه مشخص شده است.",
        "label": "نقشهٔ انتخاب موقعیت مطب",
        "hint": "روی نقشه بزنید یا پین را بکشید تا دقیقاً روی مطب قرار بگیرد؛ سپس «ذخیره» را بزنید.",
        "found": "پین روی موقعیت فعلی شما قرار گرفت. اگر الان در مطب نیستید، آن را روی مطب بگذارید.",
        "locating": "در حال یافتن موقعیت شما…",
        "loading": "در حال بارگذاری نقشه…",
        "failed": "نقشه بارگذاری نشد. اگر در مطب هستید، «موقعیت فعلی من» را بزنید.",
        "denied": "اجازهٔ دسترسی به موقعیت داده نشد؛ روی نقشه بزنید تا مطب را مشخص کنید.",
        "unavailable": "موقعیت شما پیدا نشد؛ روی نقشه بزنید تا مطب را مشخص کنید.",
        "timeout": "یافتن موقعیت طول کشید؛ دوباره تلاش کنید یا روی نقشه بزنید.",
        "unsupported": "این مرورگر موقعیت‌یابی ندارد؛ روی نقشه بزنید تا مطب را مشخص کنید."
      },
      "socials": "شبکه‌های اجتماعی",
      "socialsHint": "شناسه یا نشانی صفحه را وارد کنید (مثلاً @dr.example یا instagram.com/dr.example). واتس‌اپ: شمارهٔ کامل با کد کشور. وب‌سایت: نشانی کامل.",
      "social": {
        "instagram": "اینستاگرام",
        "telegram": "تلگرام",
        "whatsapp": "واتس‌اپ",
        "eitaa": "ایتا",
        "bale": "بله",
        "website": "وب‌سایت"
      }
    },
    "leads": {
      "intro": "درخواست‌هایی که بازدیدکنندگان از صفحهٔ شما فرستاده‌اند. پیگیری آن‌ها توسط تیم {{brand}} انجام می‌شود.",
      "name": "نام",
      "mobile": "موبایل",
      "preference": "روش و زمان تماس",
      "message": "پیام",
      "createdAt": "زمان ثبت",
      "status": "وضعیت",
      "more": "نمایش بیشتر",
      "loadFailed": "درخواست‌ها بارگذاری نشد",
      "emptyTitle": "هنوز درخواستی نرسیده است",
      "emptyHint": "نشانی صفحه را با بیماران به اشتراک بگذارید تا از طریق «درخواست نوبت» با شما در تماس باشند.",
      "notPublishedTitle": "صفحه هنوز منتشر نشده است",
      "notPublishedHint": "پس از انتشار، درخواست‌های بازدیدکنندگان اینجا نمایش داده می‌شود.",
      "channels": { "call": "تماس تلفنی", "sms": "پیامک", "whatsapp": "واتس‌اپ" },
      "times": { "morning": "صبح", "afternoon": "بعدازظهر", "evening": "عصر", "any": "هر زمان" },
      "statuses": {
        "new": "جدید",
        "contacted": "تماس گرفته شد",
        "qualified": "در حال پیگیری",
        "proposal": "در حال پیگیری",
        "negotiation": "در حال پیگیری",
        "won": "انجام شد",
        "lost": "بسته شد"
      }
    }
  }
}
